import { Component, inject, OnInit } from "@angular/core";
import { UnSubscriber } from "../../UnSubscriber";
import { Cls_MobiFile, Cls_MobiTab } from "../../models";
import { Store } from "@ngrx/store";
import { MobiOfficeUIState } from "../../state-management/mobi-office-ui.interface";
import { Observable, map } from "rxjs";
import { select_MOUI_User, select_MOUI_UserApplications } from "../../state-management/mobi-office-ui.selector";
import { GlobalService, StorageHandlerService, UserManagementService } from "../../services";
import { ToastrService } from "ngx-toastr";
import { GET_MOBIOFFICE_UI_User } from "../../state-management/mobi-office-ui.action";

@Component({
  selector: "mobi-office-lib-user-info-setting",
  templateUrl: "./user-info-setting.component.html",
  styleUrl: "./user-info-setting.component.scss",
  standalone: false,
})
export class UserInfoSettingComponent extends UnSubscriber implements OnInit {
  private readonly store = inject<Store<MobiOfficeUIState>>(Store);
  private readonly userManagementService = inject(UserManagementService);
  private readonly toastr = inject(ToastrService);
  private readonly globalService = inject(GlobalService);
  private readonly storageHandlerService = inject(StorageHandlerService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.GetUserProfile();
    this.getUserProfileConfiguration();
    this.getCountryCodes();
  }

  tabs: Cls_MobiTab[] = [
    {
      tabName: "My Details",
      tabValue: "My Details",
    },
    {
      tabName: "Forgot Password",
      tabValue: "Forgot Password",
    },
  ];
  selectedTab: string = "My Details";
  Username: string = "";
  FirstName: string = "";
  EmailID: string = "";
  Phone: string = "";
  errorMessages: string[] = [];
  currentPassword: string = "";
  newPassword: string = "";
  confirmPassword: string = "";
  UserApiKey: string = "";
  userLogo: Cls_MobiFile[] = [];
  USER_PROFILE_CONFIGURATION = {
    ID: 0,
    CID: 0,
    canChangeProfile: true,
    canChangeName: true,
    canChangeUserName: true,
    canChangePhoneNumber: true,
    canChangeEmail: true,
    canChangePassword: true,
  };
  countryList: any[] = [];
  selectedCountry: string = "91";

  get userInfo$(): Observable<any> {
    return this.store.select(select_MOUI_User).pipe(map(res => res?.UserInfo));
  }

  get applicationInfo$(): Observable<any> {
    return this.store.select(select_MOUI_UserApplications).pipe(map(res => res?.ApplicationsList));
  }

  private GetUserProfile() {
    this.anotherSubscription = this.userManagementService.GetUserProfile().subscribe((res: any) => {
      const { Table } = res;
      this.FirstName = Table?.Name;
      this.Username = Table?.Username;
      this.Phone = Table.Phone.startsWith(Table.PhonePreFix) ? Table.Phone.substring(Table.PhonePreFix.length) : Table.Phone;
      this.selectedCountry = Table.PhonePreFix;
      this.EmailID = Table?.EmailID;
      this.UserApiKey = Table?.UserApiKey;
      this.userLogo = [
        {
          fileName: Table.UserLogoName,
          fileType: Table.UserLogoType,
          fileSize: Table.UserLogoSize,
          fileUrl: Table.UserLogoUrl,
        },
      ];
    });
  }

  private getCountryCodes() {
    this.anotherSubscription = this.userManagementService.GetCountryWithPhoneCodes().subscribe((res: any) => {
      const { Table } = res;
      this.countryList = Table;
    });
  }

  private getUserProfileConfiguration() {
    this.anotherSubscription = this.userManagementService.GetUserProfileConfiguration().subscribe((res: any) => {
      const { Table } = res;
      this.USER_PROFILE_CONFIGURATION = Table || {
        ID: 0,
        CID: 0,
        canChangeProfile: true,
        canChangeName: true,
        canChangeUserName: true,
        canChangePhoneNumber: true,
        canChangeEmail: true,
        canChangePassword: true,
      };
    });
  }

  onGenerateApiKey() {
    this.UserApiKey = this.globalService.randomValue(true, true, 30);
  }

  private validateProfile(): boolean {
    let isValid: boolean = true;
    this.errorMessages = [];

    if (!this.userLogo?.length) {
      this.errorMessages.push("Upload Profile");
    }

    if (!this.FirstName?.trim()) {
      this.errorMessages.push("Name");
    }

    if (!this.Username?.trim()) {
      this.errorMessages.push("Username");
    }

    if (!this.selectedCountry) {
      this.errorMessages.push("Country");
    }

    if (!this.Phone?.trim()) {
      this.errorMessages.push("Phone");
    }

    if (!this.EmailID?.trim()) {
      this.errorMessages.push("EmailID");
    } else {
      if (!this.globalService.validateEmail(this.EmailID)) {
        this.errorMessages.push("Invalid EmailID");
      }
    }

    if (this.errorMessages?.length) {
      this.toastr.info(this.globalService.errorMessage, "Info");
      isValid = false;
    }

    return isValid;
  }

  private resetPasswords() {
    this.currentPassword = "";
    this.confirmPassword = "";
    this.newPassword = "";
  }

  onTabChange() {
    this.errorMessages = [];
    this.resetPasswords();
    if (this.selectedTab === "My Details") this.GetUserProfile();
  }

  onUpdateProfile() {
    if (!this.validateProfile()) return;
    const tempModal = new Cls_User();
    tempModal.Name = `${this.FirstName?.trim()}`;
    tempModal.Username = this.Username?.trim();
    tempModal.EmailID = this.EmailID?.trim();
    tempModal.UserApiKey = this.UserApiKey?.trim();
    tempModal.PhonePreFix = this.selectedCountry?.trim();
    tempModal.Phone = `${this.selectedCountry?.trim() || ""}${this.Phone?.trim() || ""}`;
    tempModal.UserLogoName = this.userLogo[0].fileName;
    tempModal.UserLogoUrl = this.userLogo[0].fileUrl;
    tempModal.UserLogoType = this.userLogo[0].fileType;
    tempModal.UserLogoSize = this.userLogo[0].fileSize || 0;
    this.anotherSubscription = this.userManagementService.UpdateUserInfo(tempModal).subscribe((res: any) => {
      const { message } = res;
      this.toastr.success(message, "Success");
      this.GetUserProfile();

      // Recall user info of token is available
      const token = this.storageHandlerService.getItem("token");
      if (token) this.store.dispatch(GET_MOBIOFFICE_UI_User());
    });
  }

  // Password Update

  private validatePassword(): boolean {
    let isValid: boolean = true;
    this.errorMessages = [];

    if (!this.currentPassword?.trim()) {
      this.errorMessages.push("Current Password");
    }

    if (!this.newPassword?.trim()) {
      this.errorMessages.push("New Password");
    } else {
      if (this.newPassword?.trim()?.length <= 3) {
        this.errorMessages.push("Password should contain morethan 3 characters");
      }
    }

    if (!this.confirmPassword?.trim()) {
      this.errorMessages.push("Confirm Password");
    } else {
      if (this.newPassword?.trim() !== this.confirmPassword?.trim()) {
        this.errorMessages.push("Confirmation password not matching with new password");
      }
    }

    if (this.errorMessages?.length) {
      isValid = false;
      this.toastr.info(this.globalService.errorMessage, "Info");
    }

    return isValid;
  }

  onUpdatePassword() {
    if (!this.validatePassword()) return;
    const tempModal: Int_UserPassword = {
      CurrentPassword: this.currentPassword?.trim(),
      NewPassword: this.newPassword?.trim(),
    };
    this.anotherSubscription = this.userManagementService.UpdateUserPassword(tempModal).subscribe((res: any) => {
      this.toastr.success(res.message, "Success");
      this.resetPasswords();
    });
  }
}

interface Int_UserPassword {
  CurrentPassword: string;
  NewPassword: string;
}

class Cls_User {
  UID!: number;
  CID!: number;
  Name!: string;
  Username!: string;
  UserApiKey!: string;
  EmailID!: string;
  Password!: string;
  Phone!: string;
  PhonePreFix!: string;
  UserToken!: string;
  UserLogoName!: string;
  UserLogoUrl!: string;
  UserLogoSize!: number;
  UserLogoType!: string;
}
